import { KYMW0A00Model } from '../kymw0a00.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonUploadServiceSub } from '../../../kymw00/pless-json-upload-sub.service';

/**
 * 組合員の声データ取込みサービス
 *
 * @export UploadMembersVoiceDataService
 * @class UploadMembersVoiceDataService
 * @extends {PlessJsonUploadServiceSub}
 */
@Injectable()
export class UploadMembersVoiceDataService extends PlessJsonUploadServiceSub<any> {
  private model: KYMW0A00Model = null;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param model KYMW0A00Model
   * @memberof UploadMembersVoiceDataService
   */
  execute(model: KYMW0A00Model, file: File, successFunc: Function): void {
    this.model = model;
    this.successFunc = successFunc;
    this.sendFile('uploadMembersVoiceData', '', file);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UploadMembersVoiceDataService
   */
  success(data: any): void {
    // サーバからの結果を元に、処理ログ登録用VOを更新する
    this.model.uploadMembersVoiceData(data);
    // 後続処理を実行
    this.successFunc();
  }
}
